import { render, staticRenderFns } from "./scene-3.vue?vue&type=template&id=349308a3"
import script from "./scene-3.vue?vue&type=script&lang=js"
export * from "./scene-3.vue?vue&type=script&lang=js"
import style0 from "./scene-3.vue?vue&type=style&index=0&id=349308a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports